import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The page for a URL that matches no route.
 *
 * Without it an unmatched path rendered nothing at all — a blank white screen
 * with no heading, no explanation and no way back, which is what a parent or a
 * SENCO following a stale or mistyped link saw. Found on staging, 28 October
 * 2026.
 *
 * Deliberately plain: it has to work for both products, signed in or out, and
 * before any org or pathway context exists, so it names no service and offers
 * the one thing that always works — a way back to the start.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md text-left">
        <h1 className="text-2xl font-bold mb-2">We could not find that page</h1>
        <p className="text-base text-gray-700 mb-6">
          The link may be out of date, or the address may have been typed
          incorrectly.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center min-h-[44px] px-5 rounded-lg
                     bg-[#43213E] text-white text-base font-semibold no-underline
                     focus-visible:outline focus-visible:outline-[3px]
                     focus-visible:outline-offset-2 focus-visible:outline-[#43213E]"
        >
          Go to sign in
        </Link>
      </div>
    </div>
  );
}
